import { CircularProgress } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"

export default function Modal({
  isOpen,
  close,
  title,
  children,
  cancelText = "Cancel",
  actionText = "OK",
  action,
  cancelAction,
  loading,
  noActions,
  maxWidth = "sm",
  disabled,
}) {
  return (
    <Dialog open={isOpen} onClose={close} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ textAlign: "center" }}>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {!noActions && (
        <DialogActions>
          <Button onClick={cancelAction || close}>{cancelText}</Button>
          <Button
            disabled={disabled || loading}
            variant="contained"
            onClick={action}
            autoFocus
          >
            {loading ? <CircularProgress size={"1.6rem"} /> : actionText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
